import styled from "styled-components";
import CTAButton from "../cta-button/cta-button";

export const LoginButtonStyled = styled(CTAButton)`
  margin: 0 0;
  padding: 12px 16px;
  gap: 8px;
`;
